import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar-min.webp";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              QUICK <span className="purple"> BIO </span>
            </h1>
            <p className="home-about-body">
              I have been fascinated with technology since tinkering with our family's old Windows 95 machine as a kid.
              Today, I build software that solves real operational problems.
              <br />
              <br />
              As a
              <i> <b className="purple"> Technical Operations Engineer </b> </i>
              at Bright Future Stars, I built an
              <i> <b className="purple"> automation tool </b> </i>
              that processes session data, applies billing rules, catches errors, and generates monthly reports,
              supporting a team of 30 and
              <i> <b className="purple"> 300–1,000 healthcare claims a month. </b> </i>
              Before that, I was a
              <i> <b className="purple"> Software Engineer at AspenTech, </b> </i>
              troubleshooting and validating production systems with cross-functional teams.
              <br />
              <br />
              I work across the stack with
              <i> <b className="purple"> Java, Python, React, and Node.js, </b> </i>
              and I use
              <i> <b className="purple"> AI tools like Claude Code and GitHub Copilot </b> </i>
              to ship faster without cutting corners.
              <br />
              <br />
              Outside of development, I enjoy listening to music and traveling.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <img src={myImg} className="img-fluid" alt="avatar" style={{maxHeight: "350px"}} />
          </Col>
        </Row>
        <br></br>
        <br></br>
        <Row>
          <Col md={12} className="home-about-social">
            <i style={{ fontSize: "24px", color: "rgb(155 126 172)" }}>
            "You can’t connect the dots looking forward; you can only connect them looking backwards."
          </i>
          <br></br>
          <i style={{ fontSize: "24px", color: "rgb(155 126 172)"}}>
            -Steve Jobs
          </i>
          <br></br>
          <br></br>

          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
